jQuery(document).ready(function ($) {
    /***************************************************************************/
    // Contact Us and Subscribe Forms
    /***************************************************************************/
    //  initilize Toaster messages
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
    var _contactForm = '.contact-form';
    var _subscribeForm = '.subscribe-form';
    var _messageSendButton = '.message-send-btn';
    var _subscribeBtn = '.subscribe-btn';
    // On click Enter In contact  or subscribe form make button clicked
    $('.contact-form,.subscribe-form').on('keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            var $button = $(this).closest('form').find(':button');
            $button.click();
            $button.prop('disable',true);
            return false;
        }
    });
    // --------------------------------------------------------------------------------
    // $(".phoneInput").intlTelInput({
    //     utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js",
    //     nationalMode: true,
    //     separateDialCode: true,
    //     initialCountry: $('meta[name="initial-country"]').attr('content'), // from master page GLOBAL VARIABLE
    //     preferredCountries: ['SA', 'QA', 'TR', 'IQ', 'KW', 'BH', 'AE', 'YE', 'JO', 'DZ', 'TN', 'LY', 'EG', 'SD', 'OM', 'SY']
    // });
    // --------------------------------------------------------------------------------
    // For submit contact message Forms
    $(_messageSendButton).on('click', function (e) {
        e.preventDefault();
        var $this = $(this).parents('form');
        // var source_form = $this.find('input[name=source_form]').val();
        var phoneId = $this.find(".phoneInput").attr('id');
        var name = $this.find('input[name=name]').val();
        var email = $this.find('input[name=email]').val();
        var company_name = $this.find('input[name=company-name]').val();
        var company_industry = $this.find('input[name=company-industry]').val();
        var message_type = $this.find('input[name=message-type]:checked').val();
        var zc_gad = $this.find('input[name=zc_gad]').val();
        var mobile_number = $this.find('input[name=phone]').val();
        // var mobile_number_with_code = $this.find('input[name=phone]').intlTelInput("getNumber");
        // var countryData = $this.find('input[name=phone]').intlTelInput("getSelectedCountryData");
        // var countryCode = countryData.dialCode;
        var mobile_number_with_code = '+90' + mobile_number;
        var countryData = 'Turkey';
        var countryCode = "TR";
        var message = $this.find('input[name=message]').val();
        var valid = true;
        if (name === '') {
            valid = false;
            toastr.warning(trans._pleaseEnterNameMsg)
        } else if (mobile_number === '') {
            valid = false;
            toastr.warning(trans._pleaseEnterMobileMsg);
        } else if (!numReg.test(mobile_number)) {
            valid = false;
            toastr.warning(trans._pleaseEnterNumberOnly);
        } else if (mobile_number.length < 5) {
            valid = false;
            toastr.warning(trans._pleaseEnterValidMobileMsg);
        } else if (countryCode === 'اختر البلد') {
            valid = false;
            toastr.warning($choiceCountyCode);
        } else if (email !== '' && !emailReg.test(email)) {
            var confirm = window.confirm(trans._errorEmailMsg);
            if (!confirm) {
                valid = false;
            } else {
                email = '';
            }
        }
        var $_data = {
            name: name,
            mobile_number: mobile_number_with_code,
            email: email,
            communication_time: '',
            message: message,
            company_name: company_name,
            company_industry: company_industry,
            message_type: message_type,
            fullsrc: fullsrc,
            domain: domain,
            locale: lang,
            _token: $('meta[name="csrf-token"]').attr('content')
        };
        if (valid) {
            $(_messageSendButton).prop('disabled', true);
            // $_data['source_form'] = source_form;
            $_data['zc_gad'] = zc_gad;
            return SaveContactMessage($this, $_data);
        }
    });

    // For submit subscribe Forms
    $(_subscribeBtn).on('click', function (e) {
        e.preventDefault();
        var $this = $(this).parents('form');
        var $button = $(this);
        var email = $this.find('input[name=email]').val();
        if (email === '') {
            toastr.warning(trans._pleaseEnterEmailMsg);
        } else if (!emailReg.test(email)) {
            toastr.warning(trans._errorEmailMsg);
        } else {
            $button.prop('disabled', true);
            storeNewSubscriber($this, $button, email, lang);
        }
    });

    var dataLayer = [];

    // Send Ajax Request To save new Message in database.
    function SaveContactMessage($this, _data) {
        $.ajax({
                url: $this.attr('action'),
                method: "POST",
                dataType: "json",
                data: _data,
                beforeSend: function () {
                    $this.find('.send').addClass('d-none');
                    $this.find('.sending').removeClass('d-none');
                },
                success: function (data) {
                    if (data.error.length > 0) {
                        toastr.error(data.error);
                    } else {
                        dataLayer.push({'event': 'form_submitted'});
                        $this[0].reset();
                        toastr.success(data.success);
                        // $('#thanksForm').submit();
                    }
                    $this.find('.send').removeClass('d-none');
                    $this.find('.sending').addClass('d-none');
                    $this.find(_messageSendButton).prop('disabled', false);
                },
                error: function (data, error_status, error_message) {
                    if (data.status === 429) {
                        toastr.error(trans._TooManyAttempts);
                    } else {
                        _data['error_status'] = data.status;
                        _data['error_message'] = error_message;
                        toastr.error(trans._errorSending);
                        // ====================================================================
                    }
                }, complete: function () {
                    $this.find('.send').removeClass('d-none');
                    $this.find('.sending').addClass('d-none');
                    $(_messageSendButton).prop('disabled', false);
                }
            }
        )
        ;
    }

    // Send Ajax Request To save new Subscriber in campaigns System.
    function storeNewSubscriber($this, $button, _email, _lang) {
        _lang = (typeof _lang !== 'undefined') ? _lang : null;
        $.ajax(
            {
                url: $this.attr('action'),
                method: "POST",
                dataType: "json",
                data: {
                    email: _email,
                    locale: _lang,
                },
                beforeSend: function () {
                    $this.find('.subscribe').addClass('d-none');
                    $this.find('.subscribing').removeClass('d-none');
                },
                success: function (data) {
                    if (data.error.length > 0) {
                        toastr.warning(data.error);
                    } else {
                        toastr.success(data.success);
                        $this[0].reset();
                    }

                }, error: function (data, status, message) {
                    if (data.status === 429) {
                        toastr.error(trans._TooManyAttempts);
                    } else {
                        toastr.error(trans._errorSending);
                    }
                    $button.prop('disabled', false);
                }
                , complete: function () {
                    $this.find('.subscribe').removeClass('d-none');
                    $this.find('.subscribing').addClass('d-none');
                    $button.prop('disabled', false);
                }
            });
    }
});